import { FileInput } from '@mantine/core';
import { useDispatch } from 'react-redux';
import { parseUploadData } from '../helpers';
import { useState } from 'react';

export enum UploadFileOptions {
  Shapefile = 'Shapefile',
  GeoJSON = 'GeoJSON',
}

interface IRenderFileUpload {
  type: UploadFileOptions;
}
const RenderFileUpload = (props: IRenderFileUpload) => {
  const { type } = props;
  const [file, setFile] = useState<File | null>(null);

  // using file to set value for input in place of originUploadFile
  // needed for correct filename to show with .zip upload
  // const originUploadedFile = useSelector(originUploadedFileSelector);
  const dispatch = useDispatch();

  return (
    <div className='options-file-upload-wrapper'>
      <FileInput
        placeholder='Choose file'
        className='file-upload'
        value={file}
        withAsterisk
        variant='default'
        size='md'
        w={120}
        accept={type === UploadFileOptions.Shapefile ? '.zip' : '.geojson'}
        onChange={(event) => { setFile(event); parseUploadData(event, type, dispatch) }}
      />
    </div>
  );
};

export default RenderFileUpload;
